import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icon-delete.svg'


const _withScopeId = n => (_pushScopeId("data-v-48ccbb69"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col gap-4" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "section" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "section-title" }, "Cuentas disponibles", -1))
const _hoisted_5 = { class: "grid grid-cols-4 gap-4" }
const _hoisted_6 = { class: "flex flex-col justify-start items-start" }
const _hoisted_7 = { class: "flex flex-row items-center gap-2" }
const _hoisted_8 = {
  key: 0,
  class: "text-[12px]"
}
const _hoisted_9 = {
  key: 1,
  class: "text-[12px]"
}
const _hoisted_10 = { class: "text-[12px]" }
const _hoisted_11 = {
  key: 0,
  class: "text-[12px]"
}
const _hoisted_12 = {
  key: 1,
  class: "text-[12px]"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-3",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "flex flex-row items-center mb-5 mr-5" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center my-7" }, [
  /*#__PURE__*/_createTextVNode(" Esta acción borrara definitivamente el accionista. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ¿ Desea continuar con la acción ? ")
], -1))

import { computed, watch, ref, onMounted } from "vue";

import { useRoute } from "vue-router";
import Swal from "sweetalert2";
import { useAuthStore } from "@/stores/auth";
import { AccountService } from "@/services/account/AccountService";
import { accountStore } from "@/stores/account";

import NewModal from "@/components/atoms/NewModal.vue";
import NewAccountModal from "@/components/organisms/NewAccountModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserSharesTab',
  setup(__props) {

const authStore = useAuthStore();
const changed = ref<boolean>(false);
const shareholder = computed(() => authStore.user);
const accountStr = accountStore();

const accountService = new AccountService();

const loading = ref(false);

const route = useRoute();

const selectedDeleteAccount = ref<number>(0);
const visible = ref<boolean>(false);
const visibleDelete = ref<boolean>(false);

const activeCount = computed(() => accountStr.activeAccount);
const accounts = computed(() => accountStr.account);

watch(
  shareholder,
  (value, oldValue) => {
    if (oldValue != undefined) {
      changed.value = true;
    }
  },
  { deep: true }
);
onMounted(() => {
  getAccountServices();
});

const openModalNewAccount = () => {
  visible.value = true;
};

const openModalDeleteAccount = (id: number) => {
  visibleDelete.value = true;
  selectedDeleteAccount.value = id;
};
const submitDeleteAccount = () => {
  visibleDelete.value = false;
  selectedDeleteAccount.value = 0;
};

async function getAccountServices() {
  if (+route.params.id) {
    accountStr.query(+route.params.id);
  }
}
async function deleteAccionsta() {
  loading.value = true;

  try {
    const response = await accountService.deleteAccount(
      selectedDeleteAccount.value
    );
    if (response.success == true) {
      loading.value = false;
      submitDeleteAccount;
      getAccountServices();
      Swal.fire("¡Listo!", "El accionista fue desligado con éxito", "success");
    } else {
      Swal.fire(
        "¡Error!",
        "Lo sentimos, hubo un error, intente más tarde",
        "error"
      );
    }
  } catch (error) {
    console.log(error);
  }

  submitDeleteAccount();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (shareholder.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accounts.value?.data, (account, key) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: key,
                    class: _normalizeClass(["col-span-4 lg:col-span-1 flex justify-between items-center border rounded px-3 py-2 cursor-pointer", { 'border-[#008b4e] border-2': activeCount.value == account?.id }])
                  }, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        (
                    account?.businessName && account?.businessName.trim() != ''
                  )
                          ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(account?.businessName), 1))
                          : (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(account?.firstName) + " " + _toDisplayString(account?.lastName), 1))
                      ]),
                      _createElementVNode("p", _hoisted_10, _toDisplayString(account?.email), 1),
                      (account?.investorNumberA > 0)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_11, " ID A:" + _toDisplayString(account?.investorNumberA) + " - ID B:" + _toDisplayString(account?.investorNumberB), 1))
                        : (_openBlock(), _createElementBlock("p", _hoisted_12, " ID B:" + _toDisplayString(account?.investorNumberB), 1))
                    ]),
                    _createElementVNode("div", {
                      class: "flex items-center gap-2",
                      onClick: ($event: any) => (openModalDeleteAccount(account?.id))
                    }, _hoisted_15, 8, _hoisted_13)
                  ], 2))
                }), 128)),
                (accounts.value?.data?.length == 0 || accounts.value.data == null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, " Este usuario no tiene cuentas asociadas "))
                  : _createCommentVNode("", true),
                _createElementVNode("div", { class: "col-span-4 flex items-center mb-5 justify-start" }, [
                  _createElementVNode("button", {
                    class: "bg-button-green shadow-md text-white !rounded-full !text-[16px]",
                    onClick: openModalNewAccount
                  }, " Agregar nueva cuenta ")
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("button", {
          class: "success w-32 btn ml-auto",
          disabled: !changed.value
        }, " Guardar ", 8, _hoisted_18)
      ])
    ]),
    _createVNode(NewAccountModal, {
      visible: visible.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event))
    }, null, 8, ["visible"]),
    _createVNode(NewModal, {
      title: "Confirmación",
      visible: visibleDelete.value,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (visibleDelete.value = !visibleDelete.value))
    }, {
      default: _withCtx(() => [
        _hoisted_19
      ]),
      footer: _withCtx(() => [
        _createElementVNode("button", {
          class: "bg-darken-green shadow-md text-white",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (deleteAccionsta()))
        }, " Aceptar ")
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})